// ต้องตรงกับ app_mhs/src/loanPurpose.js และ amplify/backend/function/loanRequest/src/loanPurpose.js
// purpose ต้องตรงกับ type ในตาราง interest
export const LoanTypes = {
  NANO: { purpose: "ธุรกิจ", name: "สินเชื่อนาโนไฟแนนซ์" },
  PERSONAL: { purpose: "อุปโภค / บริโภค", name: "สินเชื่อส่วนบุคคล" },
  TRAVEL: { purpose: "ท่องเที่ยว", name: "สินเชื่อส่วนบุคคล" },
};

export const LoanPurposeDetails = [
  { label: "ลงทุนสร้างธุรกิจ", loanType: "NANO" },
  { label: "ขยายธุรกิจ", loanType: "NANO" },
  { label: "เงินทุนหมุนเวียนในธุรกิจ", loanType: "NANO" },
  { label: "ลงทุนอุปกรณ์และเครื่องมือในธุรกิจ", loanType: "NANO" },
  { label: "ปรับปรุงธุรกิจ", loanType: "NANO" },
  { label: "อุปโภค/บริโภค", loanType: "PERSONAL" },
  { label: "ท่องเที่ยว", loanType: "TRAVEL" },
  { label: "ใช้จ่ายในครอบครัว", loanType: "PERSONAL" },
];

export const getPurposeByDetail = (purposeDetail) =>
  LoanTypes[
    LoanPurposeDetails.find((item) => item.label === purposeDetail)?.loanType
  ]?.purpose;
